import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { fileUrl } from "@/lib/api";

export const LogoMark = ({ className = "h-9 w-9" }) => {
  const { logo } = useSettings();
  if (logo) return <img src={fileUrl(logo)} alt="Logo UAPHARCO" data-testid="site-logo-image" className={`${className} object-contain shrink-0`} />;
  return (
    <div className={`${className} rounded-xl bg-emerald-700 text-white grid place-items-center shadow-inner shrink-0`}>
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
        <path d="M12 5v14M5 12h14" />
      </svg>
    </div>
  );
};

export const Logo = ({ light = false, compact = false }) => (
  <Link to="/" data-testid="site-logo-link" className="flex items-center gap-3">
    <LogoMark className="h-10 w-10" />
    <div className={`leading-tight ${compact ? "hidden sm:block" : ""}`}>
      <div className={`font-display font-extrabold tracking-tight text-lg ${light ? "text-white" : "text-slate-900"}`}>UAPHARCO</div>
      <div data-testid="site-logo-subtitle" className={`text-[10px] uppercase tracking-[0.12em] ${light ? "text-emerald-200" : "text-emerald-700"}`}>Union des assistants en pharmacie du Congo</div>
    </div>
  </Link>
);
